export const GET_NATIONALITIES_SUCCESS = 'GET_NATIONALITIES_SUCCESS'

export const getNationalitiesSuccess = (value) => {
  return {
    type: GET_NATIONALITIES_SUCCESS,
    data: value,
  }
}
